export const AddressChangeContactConst = {
    address: "",
    provinceCode: "",
    districtCode: "",
    wardCode: "",
    emailUpDate: "",
    phoneUpDate: "",
}